import { takeLatest, call, put } from "redux-saga/effects";

import AudioFileService from "../../../services/AudioFile/AudioFileService";
import * as types from "../actionTypes";

export function* getAudioFileInfoWatcherSaga() {
  yield takeLatest(types.API_V1_GET_AUDIO_FILE_INFO_REQUEST, workerSaga);
}

export function* workerSaga({ accountIds }) {
  try {
    yield put({
      type: types.AUDIO_LOADING,
      payload: true,
    });
    const data = yield call(AudioFileService.getAudioFileInfo, accountIds);
    if (data) {
      yield put({
        type: types.API_V1_GET_AUDIO_FILE_INFO_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    yield put({ type: types.API_V1_GET_AUDIO_FILE_INFO_FAILURE });
    return { error: error };
  }
  yield put({
    type: types.AUDIO_LOADING,
    payload: false,
  });
}
